import {Component} from "@angular/core";
import {ShiftEntityModel} from "../shift-entity.model";
import {ShiftSearchModel} from "../shift-search.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-shift-search-page",
    templateUrl: "./shift-search-page.component.html",
    providers: [provideEntityModel(ShiftEntityModel), provideSearchModel(ShiftSearchModel)]
})
export class ShiftSearchPageComponent extends AbstractSearchPage {
}
